import { AnnotationsOptions, SeriesOptions } from "highcharts";
import { DateFormatT, DateTimeFormatService } from "../services/date-time-format/date-time-format.service";
import { ITimesTemp } from "@wind-log_library/fe-component-library";
import Highcharts from "highcharts";
import moment from "moment";
import { MS_IN_10_MIN } from "./time.contants";

export function cleanChart(ref: any) {
  for (let i = (ref?.series || []).length - 1; i >= 0; i--) {
    ref?.series[i].remove();
  }
  for (let i = (ref?.annotations || []).length - 1; i >= 0; i--) {
    ref?.annotations[i].remove();
  }
}
  
export function updateChart(ref: any, series: SeriesOptions[] = null, annotations: AnnotationsOptions[] = null) {
  (series || []).forEach((s, i) => {
    ref?.addSeries(s);
  });
  (annotations || []).forEach(a => {
    ref?.addAnnotation(a);
  });
}

export function tickPositioner(labels: string[], maxTicks: number) {
  const k = Math.floor(labels.length / maxTicks);
  return labels.filter((l, i) => {
    return i % k === 0;
  });
}

export function getAxisRange(signals: any[], valuesKey: string) {
  if (!signals?.length) {
    return [-1, 1];
  }
  let [min, max] = signals.flatMap(d => d[valuesKey]).reduce((a, b) => {
    return [Math.min(a[0], b), Math.max(a[1], b)];
  }, [0, 1/1.25]);

  return [getAxisMin(min), getAxisMax(max)];
}
export function getAxisValue(value, k) {
  return +((value * (k || 1)).toFixed(2));
}
export function getAxisMax(value) {
  return getAxisValue(value, 1.25);
}
export function getAxisMin(value) {
  return getAxisValue(value, 1.1);
}
export function getXDateFormat(format: DateFormatT, df: DateTimeFormatService) {
  const pattern = df.getDateFormat(format);
  return pattern
    .replace('MMM', '%b')
    .replace('MM', '%m')
    .replace('yyyy', '%Y')
    .replace('yy', '%y')
    .replace('dd', '%d')
    .replace('HH', '%H')
    .replace('hh', '%I')
    .replace('mm', '%M')
    .replace('a', '%p');
}

export function setLangOptions(lang: string) {
  const localeData = moment().locale(lang).localeData();
  Highcharts.setOptions({
    lang: {
      months: localeData.months(),
      shortMonths: localeData.monthsShort(),
      weekdays: localeData.weekdays(),
      shortWeekdays: localeData.weekdaysShort()
    }
  });
  Highcharts.dateFormats.b = (ts: number) => new Intl.DateTimeFormat(lang, { month: 'short' }).format(ts);
  Highcharts.dateFormats.B = (ts: number) => new Intl.DateTimeFormat(lang, { month: 'long' }).format(ts);
}

export function roundToNearest(value) {
  const exponent = Math.floor(Math.log10(value));
  const factor = Math.pow(10, exponent);
  return Math.round(value / factor) * factor;
}

export function datasetToSeries(data, range: ITimesTemp) {
  const ts = range.startTS;
  return data.map((value, x) => [ts + x * MS_IN_10_MIN, value]);
}

function initModule(module: any) {
  if (!module) return;
  if (typeof module.default === 'function') {
    module.default(Highcharts);
  } else if (typeof module === 'function') {
    module(Highcharts);
  }
}
export async function loadHighchartsModules() {
  const exporting = await import('highcharts/modules/exporting');
  const exportData = await import('highcharts/modules/export-data');
  const offlineExporting = await import('highcharts/modules/offline-exporting');
  const annotations = await import('highcharts/modules/annotations');
  const xrange = await import('highcharts/modules/xrange');
  const pattern_fill = await import('highcharts/modules/pattern-fill');
  initModule(exporting);
  initModule(exportData);
  initModule(offlineExporting);
  initModule(annotations);
  initModule(xrange);
  initModule(pattern_fill);
}


// Helper function to generate symbol HTML
export function getSeriesSymbol(series: any): string {
  const color = series.color;
  const dashStyle = series.userOptions?.dashStyle || 'Solid';
  const type = series.userOptions?.type;
  
  if (type === 'scatter') {
    // Circle for scatter
    return `<span style="display: font-size:16px;color: ${color}; ">●</span>`;
  } else if (dashStyle === 'Dash') {
    // Dashed line
    return `<span style="display: inline-block; margin-bottom:3px; margin-right: 3px; width: 16px; border-top: 2px dashed ${color};"></span>`;
  } else if (dashStyle === 'Dot') {
    // Dotted line
    return `<span style="display: inline-block; margin-bottom:3px; margin-right: 3px; width: 16px; border-top: 2px dotted ${color};"></span>`;
  } else {
    // Solid line
    return `<span style="display: inline-block; margin-bottom:3px; margin-right: 3px; width: 16px; border-top: 2px solid ${color};"></span>`;
  }
}